import Authority from "@/enum/Authority";
import UserType from "@/enum/UserType";

export enum UserStatus {
    NORMAL = "NORMAL",
    DISABLED = "DISABLED",
    DELETED = "DELETED",
}
interface UserDTO {
    id: number;

    allowedShopIds: number[];

    authorities: Authority[];

    companyId: number;

    lastLoginTime: string;

    nickname: string;

    shopId: number;

    type: UserType;

    username: string;

    /**是否为店铺主账号 */
    isMasterAccount?: boolean;

    status: UserStatus;
}

export default UserDTO;
